import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Collapse, Input, Spin, notification } from 'antd';

import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { AuthContext } from 'components/Auth/Auth';
import Text from 'antd/lib/typography/Text';
import { isNil, noop } from 'lodash';
import { SaveOutlined } from '@ant-design/icons';
export declare type CollapsibleType = 'header' | 'disabled';
export declare type ExpandIconPosition = 'left' | 'right' | undefined;
const { Panel } = Collapse;

interface UtinaPanelProps {
  key: string | number;
  header?: React.ReactNode;
  comcode: string;
  labelAdditional?: string;
  /** @deprecated Use `collapsible="disabled"` instead */
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  showArrow?: boolean;
  prefixCls?: string;
  forceRender?: boolean;
  id?: string;
  extra?: React.ReactNode;
  collapsible?: CollapsibleType;
  children?: React.ReactNode;
}

const UtinaPanel = ({
  comcode,
  labelAdditional="",
  key,
  children,
  header = noop,
  ...otherProps
}: UtinaPanelProps) => {
  const {
    hint,
    isHidden,
    label,
    message,
    placeholder,
    required,
    isDisabled,
    style,
    styleAsString,
  } = useComponentConfiguration(comcode);

  const { pagcode, refresh, isFetching } = useDisplayFrameworkContext();
  const [newLabel, setNewLabel] = useState(null as any);
  const PresetRequest: ParPagComponentRequest = useMemo(
    () => ({
      comcode: comcode,
      comformat: '',
      comhint: hint ?? '',
      comlabel: newLabel === '' ? label! : newLabel,
      commessage: message ?? '',
      complaceholder: placeholder ?? '',
      comrequired: required,
      comstyle: styleAsString ?? '',
      comtype: '',
      pagcode: pagcode ?? '',
    }),
    [
      comcode,
      hint,
      newLabel,
      label,
      message,
      placeholder,
      required,
      styleAsString,
      pagcode,
    ]
  );
  const { isInspect } = useContext(AuthContext);

  useEffect(() => {
    if (isInspect) setNewLabel(label!);
  }, [isInspect]);

  const handleSaveNewLabel = (request: ParPagComponentRequest) => {
    updatePageComponent({
      request: request,
    }).then((res) => {
      if (res.code === '200') {
        notification.success({
          message: res.message,
          description: res.description,
        });
        refresh();
      } else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
    });
  };

  const panel = (
    <Panel
      className='ut-panel'
      key={key}
      header={
        isInspect ? (
          <Input
            value={isNil(newLabel) ? label! : newLabel}
            size="middle"
            onChange={(event) => {
              setNewLabel(event.target.value);
            }}
            className="input-inspect"
            addonAfter={
              <SaveOutlined
                style={{ color: '#00a896' }}
                onClick={(event) => {
                  event.preventDefault();
                  handleSaveNewLabel({
                    ...PresetRequest,
                    comlabel: isNil(newLabel) ? label! : newLabel,
                  });
                }}
              />
            }
          />
        ) : (
          <Text style={{ fontSize: 16, fontWeight: 'bold' }}>
            {label + ' ' + labelAdditional??''}
          </Text>
        )
      }
      {...otherProps}
    >
      <Spin spinning={isFetching}>{children}</Spin>
    </Panel>
  );

  if (isHidden) {
    return null;
  }

  return panel;
};

export default UtinaPanel;
